import api from '@/api'

const { $billing } = api;

export const { $receipt } = $billing;
